<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Subscription revenue report</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">
                Subscription revenue report
              </li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="btn-toolbar pull-right">
              <a
                href="javascript:void(0)"
                class="btn btn-info"
                @click="show_filter = !show_filter"
                ><i class="fa fa-filter"></i>Filter</a
              >
            </div>

            <div class="card-tools">
              <button class="btn btn-info" @click="exportReport()">
                <i class="fas fa-download"></i> Export
              </button>
            </div>
          </div>
          <form @submit.prevent="getFilterData()" method="GET" novalidate>
            <div class="card-body" v-if="show_filter">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-row">
                    <label class="col-md-3 col-form-label" for="username"
                      >Date range</label
                    >
                    <div class="col-md-9">
                      <date-picker
                        type="datetime"
                        input-class="form-control"
                        v-model="filter.created_at"
                        range
                        lang="en"
                        format="YYYY-MM-DD"
                        confirm
                        id="created_at"
                        value-type="YYYY-MM-DD"
                      ></date-picker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-9 offset-md-3">
                      <button type="submit" class="btn btn-common m-2px">
                        Search
                      </button>
                      <button
                        type="reset"
                        class="btn btn-warning"
                        @click="resetFilter()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-body table-responsive-md p-0">
            <table class="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Plan Name</th>
                  <th>Total Subscription Revenue</th>
                  <th>Sum of Active Subscriber till date</th>
                  <th>Canceled Subscription</th>
                  <!-- <th>Subscription Success Count</th>
                  <th>Subscription Failed Count</th> -->
                  <th>New Subscription Attempt</th>
                  <th>New Subscription Count</th>
                  <th>New Subscription Revenue</th>
                  <th>Re-order Count</th>
                  <th>Re-order Revenue</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(revenue, index) in revenueAll.data">
                  <td>{{ revenue.sub_date }}</td>
                  <td>{{ revenue.name }}</td>
                  <td>{{ revenue.total_revenue }}</td>
                  <td>{{ revenue.total_active_subscriber }}</td>
                  <td>{{ revenue.total_unsub }}</td>
                  <!-- <td>{{ revenue.subscription_success_count }}</td>
                  <td>{{ revenue.subscription_failed_count }}</td> -->
                  <td>{{ revenue.new_subscription_attempt_count }}</td>
                  <td>{{ revenue.new_subscription_count }}</td>
                  <td>{{ revenue.new_subscription_revenue }}</td>
                  <td>{{ revenue.renewal_count }}</td>
                  <td>{{ revenue.renewal_revenue }}</td>
                </tr>
              </tbody>
            </table>

            <div class="p-4" v-if="_.isEmpty(revenueAll.data)">
              <div class="alert alert-default-warning" role="alert">
                No data found!
              </div>
            </div>
          </div>
          <div class="card-footer">
            <vue-pagination
              :pagination="revenueAll"
              v-if="revenueAll.total > revenueAll.per_page"
              @paginate="init()"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VuePagination from "@/components/partials/PaginationComponent";
import { LearningReportApi } from "@/services/api";
import SortIcons from "@/components/utils/SortIcons";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import fileDownload from "js-file-download";

export default {
  name: "SubscriptionRevenue",
  metaInfo: {
    title: "Subscription revenue | Dotlines",
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons,
  },
  data: () => ({
    revenueAll: {
      total: 0,
      per_page: 1,
      from: 1,
      to: 0,
      current_page: 1,
    },
    show_filter: false,
    filter: {},
    is_loading: false,
  }),
  methods: {
    init() {
      this.filter = JSON.parse(JSON.stringify(this.$route.query));
      if (!_.isEmpty(this.filter)) this.show_filter = true;
      this.is_loading = true;
      let params = { ...this.filter, ...this.$route.query };
      LearningReportApi.subscriptionRevenue(params)
        .then((response) => {
          this.revenueAll = response;
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    async getFilterData() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.filter,
        })
        .catch((err) => {
          console.log(err);
        });
    },
    exportReport: function () {
      this.is_loading = true;
      axios
        .get("/reports/subscription/revenue-export", {
          params: this.filter,
          responseType: "blob",
        })
        .then((response) => {
          fileDownload(response.data, "subscription-revenue.xlsx");
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
  },
  mounted() {
    this.init();
    this.$root.$on("sort-data", () => {
      this.$root.$emit("show-icon");
    });
  },
  watch: {
    "$route.query"() {
      this.init();
    },
  },
};
</script>
